import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { SocketContext, socket } from "./components/Services/SocketApi";
import Spinner from "./components/Services/Spinner";
import "./App.scss";

const Home = lazy(() => import("./components/Home/Home"));
const Admin = lazy(() => import("./components/Admin/Admin"));
const News = lazy(() => import("./components/News/News"));
const AboutUs = lazy(() => import("./components/AboutUs/AboutUs"));
const SignUp = lazy(() => import("./components/SignUp/SignUp"));
const SignIn = lazy(() => import("./components/SingnIn/SignIn"));
const SignOut = lazy(() => import("./components/SignOut/SignOut"));
const NotFound = lazy(() => import("./components/NotFound/NotFound"));

const App = () => {

  return (
    <SocketContext.Provider value={socket}>
      <BrowserRouter>
        <Suspense fallback={<Spinner />}>
          <Switch>
            <Route exact path={"/"} component={Home} />
            <Route exact path={"/admin"} component={Admin} />
            <Route exact path={"/news"} component={News} />
            <Route path={"/news/:newsTitle"} component={News} />
            <Route exact path={"/about-us"} component={AboutUs} />
            <Route exact path={"/signin-admin"} component={SignIn} />
            <Route path={"/signout"} component={SignOut} />
            <Route exact path={"/signup-admin"} component={SignUp} />
            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </BrowserRouter>
    </SocketContext.Provider>
  )
}

export default App;
